import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import SalesSummary from "../../../common/salarySummery";
import {
  getFirstDateOfCurrentMonthPayloadFormate,
  getFirstDateOfMonth,
  getLastDateOfCurrentMonthPayloadFormat,
  payloadDateFormat,
} from "../../../utils/commonUtils";
import { getCounterSalesReport, getCounterSalesReportxlsx } from "./reportsApi";
import TableReport from "./table";
import DateComponent from "./dateComponent";
import axios from "axios";
import { GETCOUNTERSALESREPORTXLSX } from "../../../utils/api";

const data = [
  { category: "Hair Wash", items: 11, amount: "₹ 2443.38", percent: "56.09%" },
  {
    category: "Head Massage",
    items: 21,
    amount: "₹ 2443.38",
    percent: "77.00%",
  },
  { category: "Manicure", items: 1, amount: "₹ 2443.38", percent: "44.00%" },
  {
    category: "Basic Facial",
    items: 3,
    amount: "₹ 2443.38",
    percent: "33.00%",
  },
  { category: "Shaving", items: 4, amount: "₹ 2443.38", percent: "33.00%" },
  {
    category: "Detox Treatment",
    items: 5,
    amount: "₹ 2443.38",
    percent: "33.00%",
  },
  {
    category: "Eyelash Lifting",
    items: 23,
    amount: "₹ 2443.38",
    percent: "44.00%",
  },
];

export default function ItemWiseCategoryCounter() {
  const [dateValue, setDateValue] = useState(null);
  const salesData = [
    { label: "Total Sale", today: "0.00", monthly: "77801.95" },
    { label: "Counter Sale", today: "0.00", monthly: "77801.95" },
    { label: "Credit Sale", today: "0.00", monthly: "0.00" },
    { label: "Expenses", today: "0.00", monthly: "14000.00" },
    { label: "Number of Bills", today: "0", monthly: "38" },
    { label: "Product Sold", today: "0", monthly: "58" },
    { label: "Service Sold", today: "0", monthly: "26" },
  ];

  const [open, setOpen] = useState(false);

  function addLeadingZero(value) {
    return value < 10 ? "0" + value : value;
  }

  const displayDateFormat = () => {
    var currentDate = new Date();
    let dateContainer = String(currentDate).split(" ");

    var year = dateContainer[2];
    var month = dateContainer[1];

    var day = dateContainer[3];

    var formattedDate =
      year + "-" + addLeadingZero(month) + "-" + addLeadingZero(day);

    return formattedDate;
  };
  const [gstReports, setgstReports] = useState({
    totalSales: "",
    gstReports: [],
  });
  const [counterSales, setCounterSales] = useState();
  const [billFilter, setBillFilter] = useState("cash");

  const [date, setDate] = useState(null);
  const [displayEndDate, setDisplayEndDate] = useState(null);
  const [dateFocused, setDateFocused] = useState(false);

  const [SelectedStartDate, setSelectedStartDate] = useState(dayjs());
  const [startDateFormat, setstartDateFormat] =  useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());

  const datePickerRef = useRef();
  const datePickerRef2 = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const getCounterSales = async (param) => {
    await getCounterSalesReport(param)
      .then((res) => {
        console.log("sales Report ", res?.data?.data);
        setCounterSales(res?.data?.data);
      })
      .catch((err) => {
        console.log("err ", err);
      });
  };

  const datePickerOnChange = (date) => {
    const dateStr = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const dateStr2 = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
    const [month, day, year] = dateStr.split("/");
    const formattedDate = `${year}-${day.padStart(2, "0")}-${month.padStart(
      2,
      "0"
    )}`;
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    datePickerRef2.current.setOpen(true);

    setDate(formattedDate2);
    setstartDateFormat(formattedDate);
    setSelectedStartDate(date);
  };
  const datePickerOnChangeEnd = (date) => {
    const dateStr = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const dateStr2 = date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
    const [month, day, year] = dateStr.split("/");
    const formattedDate = `${year}-${day.padStart(2, "0")}-${month.padStart(
      2,
      "0"
    )}`;
    let dateContainer = String(dateStr2).split(" ");
    var year2 = dateContainer[2];
    var month2 = dateContainer[1];
    var day2 = dateContainer[0];
    var formattedDate2 = day2 + "-" + month2 + "-" + year2;
    console.log("format date ", formattedDate);
    datePickerRef2.current.setOpen(true);
    setSelectedEndDate(date);
    setDisplayEndDate(formattedDate2);
    setEndDate(formattedDate);
  };

  useEffect(() => {
    console.log("start date ", startDateFormat);
    console.log("display End ", endDate);
    getCounterSales({
      fromDate: startDateFormat,
      toDate: endDate,
    });
  }, [startDateFormat, endDate]);
  useEffect(() => {
    console.log("datE ", payloadDateFormat());
    getCounterSales({
      fromDate: startDateFormat,
      toDate: endDate,
    });
  }, []);

  const downloadXLSXFile = async (param) => {
    try {
      // const response = await axios.post(
      //   GETCOUNTERSALESREPORTXLSX,
      //   param,
      //   {
      //     responseType: "blob",
      //   }
      // );

      const response = await getCounterSalesReportxlsx(param, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };

  const [SelectedEndDate, setSelectedEndDate] = useState(dayjs());
  return (
    <Box sx={{ p: "17px 20px", background: "#ede9ff", minHeight: "100vh" }}>
      <Grid container alignItems="center">
        <Grid
          item
          xs={12}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B", // optional text color
            textAlign: "left",
            marginBottom: "10px",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "12px", sm: "14px", md: "18px" },
            }}
          >
            Item Wise Counter Sale Report
          </Typography>
        </Grid>

        {/* Date Input */}
        <Grid
          item
          xs={12}
          sm={12}
          md={10}
          sx={{
            p: "10px 0px",
            paddingRight: "10px",
          }}
        >
          <DateComponent
            date={date}
            setDate={setDate}
            setCounterSales={setCounterSales}
            displayEndDate={displayEndDate}
            setDisplayEndDate={setDisplayEndDate}
            dateFocused={dateFocused}
            setDateFocused={setDateFocused}
            SelectedStartDate={SelectedStartDate}
            setSelectedStartDate={setSelectedStartDate}
            startDateFormat={startDateFormat}
            setstartDateFormat={setstartDateFormat}
            endDate={endDate}
            setEndDate={setEndDate}
            SelectedEndDate={SelectedEndDate}
            setSelectedEndDate={setSelectedEndDate}
          />
        </Grid>

        {/* Download Button */}
        <Grid
          item
          md={2}
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              downloadXLSXFile({
                fromDate: startDateFormat,
                toDate: endDate,
              });
            }}
            sx={{
              height: "40px",
              backgroundColor: "#14008B",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
            endIcon={<DownloadIcon />}
          >
            Download
          </Button>
        </Grid>

        {/* Total Sale */}
        <Grid
          item
          xs={"auto"}
          sx={{
            padding: "8px 16px",
            margin: "8px 8px 0px 0",
            fontWeight: "500",
            backgroundColor: "#CCCCFF",
            borderRadius: "8px",
          }}
        >
          <Typography
            component="p"
            sx={{
              display: "flex",
              alignItems: "center",
              marginLeft: "5px",
              color: "#00008B",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Total Sale:&nbsp;&nbsp;&nbsp;
              {/* (
                    <Typography component="span">
                      <CurrencyRupeeIcon color="dark" fontSize="10px" />
                    </Typography>) : */}
            </Typography>
            <Typography
              component="span"
              sx={{
                fontWeight: "bold",
                marginLeft: "8px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              {" "}
              {counterSales?.totalAmount?.toFixed(2)}
            </Typography>
          </Typography>
        </Grid>
      </Grid>

      {/* Table */}
      <Box mt={4} sx={{ borderRadius: 3, background: "#fff" }}>
        <TableReport
          salesData={salesData ?? []}
          colName={[
            {
              title: "Category",
              attribute: {
                xs: 3,
              },
            },
            {
              title: "Items",
              attribute: {
                xs: 3,
              },
            },
            {
              title: "Amount",
              attribute: {
                xs: 3,
              },
            },
            {
              title: "Category",
              attribute: {
                xs: 3,
              },
            },
          ]}
          data={[...(counterSales?.counterSalesDetails ?? [])]}
        />
      </Box>
    </Box>
  );
}
